import {
  IconCalendarWeekFilled,
  IconClockFilled,
  IconUserFilled,
} from "@tabler/icons-react";
import appColors from "../../../theme/common/colors";
import appAssets from "../../../constants/assets";
import dayjs from "dayjs";

const LeaveDetailsCard = ({ record }: { record: any }) => {
  return (
    <div className="bg-bggray p-3 py-2 rounded-2xl text-black">
      <div className=" flex items-center gap-2 justify-between">
        <div className="flex-col flex gap-1">
          <div className="flex items-center gap-2">
            <IconUserFilled
              size={22}
              strokeWidth={2.4}
              fill={appColors.primary}
            />
            <p className="text-[20px]  font-regular">
              {record?.student_name ?? "Unknown"}
            </p>
          </div>
          <div className="h-[1px] bg-slate-300 px-6 mt-1 "></div>
          <div className="mt-2 flex items-center gap-4 justify-between">
            <div className="flex items-center gap-2 mr-3">
              <IconClockFilled
                size={24}
                color={appColors.green}
                strokeWidth={2}
                style={{ marginTop: 3 }}
              />
              <div>
                <p className="text-[12px] font-regular text-slate-500">
                  Duration
                </p>
                <p className="text-[15px] font-medium">
                  {record?.dayofabsence}{" "}
                  {record?.dayofabsence > 1 ? "days" : "day"}
                </p>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <IconCalendarWeekFilled
                size={24}
                fill={"#eb7153"}
                strokeWidth={2}
                style={{ marginTop: 3 }}
              />
              <div>
                <p className="text-[12px] font-regular text-slate-500">
                  Start Date
                </p>
                <p className="text-[15px] font-medium">
                  {dayjs(record?.start_date).format("MM/DD/YYYY")}
                </p>
              </div>
            </div>
            To
            <div className="flex items-center gap-2">
              <div>
                <p className="text-[12px] font-regular text-slate-500">
                  End Date
                </p>
                <p className="text-[15px] font-medium">
                  {dayjs(record?.end_date).format("MM/DD/YYYY")}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="mr-2">
          <img
            src={appAssets.images.calendar}
            alt="Calendar"
            className="w-[140px]"
          />
        </div>
      </div>
    </div>
  );
};

export default LeaveDetailsCard;
